'use strict';

import React from 'react';
import $ from 'jquery';

require('styles/Loading.less');

class LoadingComponent extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
  }
  render() {
    const { cl } = this.props;
    return (
      <div id='loading' className={cl}>
        <span>LOADING</span>
      </div>
    );
  }
}

LoadingComponent.displayName = 'LoadingComponent';

// Uncomment properties you need
// LoadingComponent.propTypes = {};
// LoadingComponent.defaultProps = {};

export default LoadingComponent;



/** WEBPACK FOOTER **
 ** ./src/components/LoadingComponent.js
 **/